import CustomFieldsProxy from "../custom-fields-proxy";
import Moment from "moment";
import Task from "./task";
import DatetimeUtils from "../../gd/utils/datetime-utils";
import {momentRange} from "../../gd/convert/moment-range";

const debug = false
// const debug = 'AssignedTask'

export default class AssignedTask extends Task {

    public dbTimeAllocation     : any
    public timeAllocation       : any
    public dateRange            : any

    constructor(data:any) {
        super(data, {useProxy: false});
        this.dbTimeAllocation   = _.get(data, 'timeAllocation', null)
        this.timeAllocation     = this._normalizeTimeAllocation()

        // create dateRange
        this._updateDateRange()

        return new Proxy(this, CustomFieldsProxy);
    }

    _normalizeTimeAllocation(data?:any) {
        // patch: convert old data with manual mode
        if (this.dbTimeAllocation && this.dbTimeAllocation.mode === gd.const.timeline.timeAllocation.distributionMode.MANUAL && _.isEmpty(this.dbTimeAllocation.allocated)) this.dbTimeAllocation = null

        const res : any = {}
        const dbTimeAllocation = data ? data.timeAllocation : _.clone(this.dbTimeAllocation)
        const company = gd.session.companies.get(gd.companyId)

        switch (company.settings.modules.workload.allocationMode) {
            case gd.const.timeline.timeAllocation.distributionMode.AUTO:
                res.allocated = _.get(dbTimeAllocation, 'allocated', {})
                res.mode =      _.get(dbTimeAllocation, 'mode', company.settings.modules.workload.allocationMode)
                res.type =      _.get(dbTimeAllocation, 'type', company.settings.modules.workload.allocationType)
                break;

            case gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED:
                res.allocated = _.get(dbTimeAllocation, 'allocated', {})
                res.mode =      _.get(dbTimeAllocation, 'mode', company.settings.modules.workload.allocationMode)
                res.type =      _.get(dbTimeAllocation, 'type', company.settings.modules.workload.allocationType)
                break;

            case gd.const.timeline.timeAllocation.distributionMode.MANUAL:
            default:
                res.allocated = _.get(dbTimeAllocation, 'allocated', {})
                res.mode =      _.get(dbTimeAllocation, 'mode', gd.const.timeline.timeAllocation.distributionMode.MANUAL)
                res.type =      _.get(dbTimeAllocation, 'type', null)
                break;
        }

        // old auto_full_time normalization
        if (company.settings.modules.workload.allocationMode === gd.const.timeline.timeAllocation.distributionMode.AUTO &&
            ![
                gd.const.timeline.timeAllocation.autoDistributionType.FRONT_LOAD,
                gd.const.timeline.timeAllocation.autoDistributionType.BACK_LOAD,
                gd.const.timeline.timeAllocation.autoDistributionType.EVENLY
            ].includes(res.type) &&
            res.mode !== gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED) {
            res.mode = gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED;
            res.type = 100;
        }

        return res
    }

    _updateDateRange() {
        if (this.startDate) {
            if (!this.endDate) this.endDate = this.startDate; // just in case ...
            // this.dateRange = Moment.range(this.startDate, this.endDate);
            this.dateRange = momentRange(this.startDate, this.endDate);
        } else {
            this.dateRange = null;
        }
    }

    applyDelta(data:any):boolean {
        _.mapKeys(data, (value ,key)=>{
            if (key === 'id') return;

            debug && console.log(debug, "applyDelta key=", key, "value=", value)

            switch (key) {
                case 'latestActivityDate'       :
                    this.latestActivityMoment = Moment.isMoment(value) ? value : DatetimeUtils.dateToMoment(value)
                    break

                case 'actionRequiredSinceDate'  : /*skip*/ break;
                case 'taskStatusId'             : this.statusId = value; break;
                case 'systemStatusId'           : this.systemStatus = value; break;

                case 'startDate'                :
                    this.startDate = Moment.isMoment(value) ? value : DatetimeUtils.dateToMoment(value)
                    this._updateDateRange()
                    break

                case 'endDate'                  :
                    this.endDate = Moment.isMoment(value) ? value : DatetimeUtils.dateToMoment(value)
                    this._updateDateRange()
                    break

                case 'scheduleDate'             :
                case 'deadline'                 :
                    this[key] = Moment.isMoment(value) ? value : DatetimeUtils.dateToMoment(value)
                    break

                default                         :
                    // @ts-ignore
                    this[key] = value;
            }

            debug && console.log(debug, "this=", this)
        });

        return true
    }
}
